import { render, staticRenderFns } from "./governmentMemberList.vue?vue&type=template&id=9273b862&scoped=true&"
import script from "./governmentMemberList.vue?vue&type=script&lang=js&"
export * from "./governmentMemberList.vue?vue&type=script&lang=js&"
import style0 from "./governmentMemberList.vue?vue&type=style&index=0&id=9273b862&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9273b862",
  null
  
)

export default component.exports